import React, { useEffect } from "react"
import { TextFieldSeeker } from "@ui-seeker/core"
import { useValidatorSeeker } from "@app"
import { object, string } from "yup"
import useDsRepricingDataInfo from "Pages/DsRepricing/Page/@hooks/useDataInfo"
import { dsRepricingDrawerData, dsRepricingDrawerErrors } from "Pages/DsRepricing/Page/@signals"

export default function DsRepricingName() {
	const { dataInfo, setDataInfo } = useDsRepricingDataInfo(dsRepricingDrawerData.peek().name || null)

	const { errors, isValid } = useValidatorSeeker({ name: dataInfo.value }, object({
		name: string()
			.required("Name is required")
			.min(5, "Name must be at least 5 characters long")
			.max(100, "Name can be at most 100 characters long")
	}))

	useEffect(() => {
		dsRepricingDrawerErrors.value = { ...dsRepricingDrawerErrors.value, name: isValid }
	}, [JSON.stringify(errors)])

	return <TextFieldSeeker
		label="Name"
		value={dataInfo.value || ""}
		onChange={e => setDataInfo(e.target.value, "name")}
		error={errors?.name}
	/>
}
